import { colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/index'
import { Input } from '@zet/design-system/input'
import { Stack } from '@zet/design-system/layout'
import { B1, B2 } from '@zet/design-system/typography'
import { View } from 'moti'

const TextInput = ({
  label,
  placeholder,
  onChange = () => null,
  onBlur,
  value,
  // control,
  errorMessage,
  isRequired,
  isEditable,
  iconLeft,
  iconRight,
  style,
  disabled,
  inputMode,
  keyboardType,
  code,
  pointerEvents = 'auto',
}) => {
  return (
    <Stack>
      <B2 className="text-grays-80 mb-1">
        {label}
        {isRequired ? <B1 className="text-error-100 ml-1">*</B1> : <></>}
      </B2>
      <Input
        placeholder={placeholder}
        onBlur={onBlur}
        onChangeText={(value) => {
          onChange(value)
        }}
        style={style}
        value={value}
        showErrorText={errorMessage}
        intent={errorMessage ? 'error' : 'primary'}
        type={errorMessage ? 'error' : 'primary'}
        isEditable={code === 'name' || code === 'phnNo' ? false : isEditable}
        iconLeft={iconLeft}
        inputMode={inputMode}
        keyboardType={keyboardType}
        iconRight={
          errorMessage ? (
            <View className="relative top-1 mr-1">
              <Icon
                color={zetColors.error[100]}
                type="ErrorOutlined"
                size={28}
              />
            </View>
          ) : (
            iconRight
          )
        }
        noIconPadding={true}
        disabled={disabled}
        pointerEvents={pointerEvents}
      />
    </Stack>
  )
}

export default TextInput
